import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS_Mapper extends BaseFormMapper<CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS);

		return _formData;
	}

	MapValues(): Partial<CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS> {
		return {};
	}
}

const Mappings: CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS = {
	// "0":"topmostSubform[0]",
	// "1":"topmostSubform[0].Page1[0]",
	province2: 'topmostSubform[0].Page1[0].ADR_PROP1_CODE_PROVINCE[1]',
	province1: 'topmostSubform[0].Page1[0].ADR_PROP1_CODE_PROVINCE[0]',
	// "4":"topmostSubform[0].Page1[0].LAWYER_SIGNATURE[0]",
	date: 'topmostSubform[0].Page1[0].DATE_SIGNATURE[0]',
	faxNumber: 'topmostSubform[0].Page1[0].Solicitor_Fax_Number[0]',
	telephoneNumber: 'topmostSubform[0].Page1[0].SolicitorPhoneNumber[0]',
	lawfirmName: 'topmostSubform[0].Page1[0].NOTARY_FIRM_NAME[0]',
	propertyType: 'topmostSubform[0].Page1[0].RadioButtonList[0]',
	qualifications: 'topmostSubform[0].Page1[0].PARTICULARS_QUALIFICATIONS[0]',
	titleInsurancePolicyNumber:
		'topmostSubform[0].Page1[0].POLICY_NUMBER_INSURANCE[0]',
	titleInsuranceCompany: 'topmostSubform[0].Page1[0].NAME_TITLE_INSURANCE[0]',
	guarantors: 'topmostSubform[0].Page1[0].GUARANTORS[0]',
	fundsRequiredDate: 'topmostSubform[0].Page1[0].DATE_FUNDS_REQUIRED[0]',
	interestAdjustmentDate:
		'topmostSubform[0].Page1[0].INTEREST_ADJUSTMENT_DATE[0]',
	mortgageAmount: 'topmostSubform[0].Page1[0].MORTGAGE_AMOUNT[0]',
	chequePayableTo: 'topmostSubform[0].Page1[0].IN_TRUST[0]',
	trustAccountNumber: 'topmostSubform[0].Page1[0].TRUST_ACCOUNT_NUMBER[0]',
	transitNumber: 'topmostSubform[0].Page1[0].TRANSIT_NUMBER[0]',
	bankName: 'topmostSubform[0].Page1[0].BANK_NAME_TRUST_ACCOUNT[0]',
	solicitorTrustAccount:
		'topmostSubform[0].Page1[0].SOLICITOR_TRUST_ACCOUNT[0]',
	rollNumber: 'topmostSubform[0].Page1[0].ROLL_NUMBER[0]',
	municipialTaxOffice: 'topmostSubform[0].Page1[0].MUNICIPAL_TAX[0]',
	legalDescription: 'topmostSubform[0].Page1[0].LEGAL_DESCRIPTION[0]',
	propertyAddress: 'topmostSubform[0].Page1[0].ADR_PROP1_RUE1[0]',
	mortgagor: 'topmostSubform[0].Page1[0].ALL_BWR_OR_COMPANYNAME[0]',
	cibcReferenceNumber: 'topmostSubform[0].Page1[0].ID_PRET_CLIENT[0]',
	// "28":"topmostSubform[0].Page1[0].BARCODE_FAX_RETURN_LENDER[0]"
};
export interface CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS {
	cibcReferenceNumber: string;
	mortgagor: string;
	propertyAddress: string;
	legalDescription: string;

	municipialTaxOffice: string;
	rollNumber: string;

	solicitorTrustAccount: string;
	bankName: string;
	transitNumber: string;
	trustAccountNumber: string;
	chequePayableTo: string;
	mortgageAmount: string;
	interestAdjustmentDate: string;
	fundsRequiredDate: string;
	guarantors: string;

	titleInsuranceCompany: string;
	titleInsurancePolicyNumber: string;

	province1: string;
	province2: string;

	qualifications: string;

	propertyType: string;

	lawfirmName: string;
	telephoneNumber: string;
	faxNumber: string;

	date: string;
}
